import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Doughnut } from 'react-chartjs-2';
import { isEmpty, size } from "lodash";

import { fetchSuppliers } from '../../store/actions/suppliersAction'
import { fetchBanks } from '../../store/actions/banksAction'
import { fetchLabels } from '../../store/actions/labelsAction'
import { fetchUserSpendings, fetchAdminSpendings, fetchSpendingPayments } from '../../store/actions/spendingAction'
import { fetchParentCategories, fetchChildCategories } from '../../store/actions/categoriesAction'
import { Grid, List, ListItem, ListItemText, ListItemSecondaryAction, Divider, ListItemAvatar, Typography, Box } from '@mui/material';
import Currency from '../common/Currency';
import { FiberManualRecord } from '@mui/icons-material';
import SpendingBySubCategory from '../Spendings/SpendingBySubCategory';
import { getLimitDate } from './statsFunctions';

class DoughnutChart extends Component{
	state = {
		selectedCategory: "",
		spendings:{},
		spending_bank: "ALL",
	}

	componentDidMount() {
		if (this.props.isAuthenticated) {
			if(isEmpty(this.props.SPENDINGS.USER) ){
				this.props.fetchUserSpendings()
			}
			if(isEmpty(this.props.SPENDINGS.ADMIN) && this.props.view === "ADMIN" ){
				this.props.fetchAdminSpendings()
			}
	
			if(isEmpty(this.props.CATEGORIES.PARENT)){
				this.props.fetchParentCategories()
			}
			if(isEmpty(this.props.CATEGORIES.CHILD)){
				this.props.fetchChildCategories()
			}
			if(isEmpty(this.props.SUPPLIERS)){
				this.props.fetchSuppliers()
			}
			if(isEmpty(this.props.LABELS)){
				this.props.fetchLabels()
			}
			if(isEmpty(this.props.BANKS)){
				this.props.fetchBanks()
			}
		}
	}

	filterData = () => {
		const { filter_period, filter_payment, SPENDINGS, view, start_date, end_date } = this.props;
		let from = filter_period === "custom" ? start_date :  getLimitDate(filter_period)
		let list = this.filterDate(SPENDINGS[view], from, end_date)
		if ( filter_payment && filter_payment !== "all" ) {
			list = this.filterPayment(list, filter_payment)
		}
		
		return list
	}

	filterDate = (list, from, to ) => {
		console.log('====================================');
		console.log({list, from, to});
		console.log('====================================');
		if(!to){
			to = Date.now()
		}
		new Date(from).setHours(0,0,0,0)
		new Date(to).setHours(0,0,0,0)

		let filteredList = Object.values(list).filter( spending => 
			new Date(spending.spending_date) >= from 
			&& new Date(spending.spending_date) <= to
		)

		return filteredList
	}
	filterPayment = (list, filter_payment) => {
		let fully_paid = filter_payment === "fully_paid" ? true : false; 

		let filteredList = list.filter( spending => 
			spending.spending_fully_paid === fully_paid 
		)

		return filteredList
	}

	// filterBank = (list, bankID) => {
	//     return list.filter( spending => (
	// 		spending.spending_bank === bankID
	// 	))
	// }
	
	groupBy = (array, prop) => {
		const { CHILD } = this.props.CATEGORIES;

		return array.reduce((acc, obj) => {
			if ( obj.spending_status === "VALIDATE" ){
				let childCatID = obj[prop]
				var key = CHILD[childCatID].category_parent
	
				if(!acc[key]){
					acc[key] = [];
				}
				acc[key].push(obj);
			}
				return acc;
		}, {});
	}
	sum = (array, prop, amountField = "spending_amount") => {
		const { CHILD } = this.props.CATEGORIES;

		return array.reduce((acc, obj) => {
			if ( obj.spending_status === "VALIDATE" ){
				let childCatID = obj[prop]
				var key = CHILD[childCatID].category_parent

				if(!acc[key]){
					acc[key] = 0;
				}
				acc[key] += parseFloat(obj[amountField]);
			}
				return acc;
		}, {});
	}

	
	calcData = () => {
	
		const { CATEGORIES, filter_payment } = this.props;
		let catLabels = []
		let payment_data = []
		let total = 0
		let bckg = []
		let orderedlistSum = {}
		let otherSum = 0
		let otherQty = 0
		let list = this.filterData()

		let amountField = filter_payment === "rest_to_pay" ? "spending_rest_to_pay" : "spending_amount"; 

		let listSum = this.sum(list, "spending_category", amountField )
		let listQty = this.groupBy(list, "spending_category")

		if(!isEmpty(listSum) ){
			let orderedList = Object.keys(listSum).sort((a, b) => listSum[a] - listSum[b] ).reverse()
			
			total = Object.values(listSum).reduce((a, b) => a + b)
			
			// catLabels = 
			orderedList.map(catID => {
				let category = CATEGORIES.PARENT[catID]
				
				if ( Math.round(listSum[catID] / total * 100) < 1){
					console.log('=================(listSum[catID])===================');
					console.log(listSum[catID], otherSum);
					console.log('====================================');
					otherSum += listSum[catID]
					otherQty += listQty[catID]
					delete listQty[catID]
					delete listSum[catID]

				} else {
					if (category && category.category_color){
						bckg.push(category?.category_color)
					}
					orderedlistSum[catID] = listSum[catID]
					
					if (category && category.category_color){
						catLabels.push(category.category_name)
					}
				}
			})

			orderedlistSum["Autres"] = otherSum
			listSum["Autres"] = otherSum
			listQty["Autres"] = otherQty

			payment_data = Object.values(orderedlistSum)
			
			bckg.push("grey")
			catLabels.push("Autres Catégories")
			console.log({
				catLabels, 
				payment_data,
				listSum,
				listQty,
				orderedList,
				orderedlistSum,
				total,
			});     
		}

		return {
			catLabels, 
			payment_data,
			bckg,
			listSum: orderedlistSum,
			listQty,
			total
		}
	}
	handleChange = (e) => {
		const { name, value } = e.target
		this.setState({
			[name]: value
		})
	}
	render(){
		console.log("CHARTS PROPS", this.props);
		const { CATEGORIES, SPENDINGS, SUPPLIERS, view, BANKS, LABELS } = this.props;
		const { openDetails, selectedCategory} = this.state;
		let infos = {
			catLabels: [], 
			payment_data: [],
			bckg:[],
			listSum: {}, // {IDcat: sum}
			listQty: {}, // {IDcat: qtyTransaction}
			total: 0
		}
		
		if(!isEmpty(SPENDINGS[view]) && !isEmpty(CATEGORIES.CHILD) && !isEmpty(CATEGORIES.PARENT)){
			infos = this.calcData()
		}

		const { catLabels, payment_data, bckg, listSum, listQty, total } = infos;
		const data = {
			labels: catLabels,
			datasets:[
				{
					label:'Répartion des Dépenses',
					data:payment_data,
					backgroundColor:bckg,
				}
			]
		}
		return (
			<div>
				{openDetails && selectedCategory &&
					<SpendingBySubCategory 
						SPENDINGS={listQty[selectedCategory]} 
						SPENDINGSLIST={SPENDINGS[view]} 
						category={selectedCategory} 
						CATEGORIES={CATEGORIES}
						LABELS={LABELS}
						SUPPLIERS={SUPPLIERS}
						BANKS={BANKS}
						view={view}
						fetchSpendingPayments={this.props.fetchSpendingPayments}
						openFormCustom={this.props.openFormCustom}
						handleClose={
							() => this.setState({ selectedCategory: "", openDetails: false})
						} 
					/>
				}
				<Grid container spacing={2}>
				{/* {view === "ADMIN" &&
					<Grid item xs={12}>
						<FormControl variant="outlined" style={{width: "100%"}}>
							<InputLabel htmlFor="spending_bank">Compte Bancaire</InputLabel>
							<Select
								native
								onChange={this.handleChange}
								value={this.state.spending_bank}
								input={
									<OutlinedInput 
										labelWidth={135} 
										name="spending_bank" 
										id="spending_bank" 
									/>
								}
							>
								<option value="ALL" >Toutes les Comptes</option>
								{ Object.values(BANKS).map( bank  => (
									<option value={bank.bank_id} key={bank.bank_id}>
										{bank.bank_name}
									</option>
								)) }
							</Select>
						</FormControl>
					</Grid>
				} */}
					<Grid item sm={6} xs={12}>
						<Box p={2} />
						<div className="chart" style={{maxWidth: "100%"}}>
							<Doughnut
								data={data}
								options={{
									title:{
										display:false,
									},
									legend:{
										display:false,
									}
								}}
							/>
						</div>
					</Grid>
					<Grid item sm={6} xs={12}>
						<List>
							<ListItem button>
								{/* <ListItemAvatar>
									<FiberManualRecord style={{color: CATEGORIES.PARENT[catID].category_color }}/>
								</ListItemAvatar> */}

								<ListItemText 
									primary={
										<Typography >
											Total
										</Typography>
									} 
									// secondary={
									// 	// total transaction?
									// }
								/>
								<ListItemSecondaryAction>
									<ListItemText secondary={<Typography color="primary" ><Currency value={Math.round(total * 100)/ 100} /></Typography>} />
								</ListItemSecondaryAction>
							</ListItem>
							<Divider />
							{Object.keys(listSum).map( (catID, i) => (
									<Fragment key={catID}>
										<ListItem 
											button 
											onClick={ catLabels[i] !== "Autres Catégories" ? () => this.setState({ selectedCategory: catID, openDetails: true}) : undefined}
										>
											<ListItemAvatar>
												<FiberManualRecord style={{color: CATEGORIES.PARENT[catID] ? CATEGORIES.PARENT[catID].category_color: "grey" }}/>
											</ListItemAvatar>

											<ListItemText 
												primary={
													<Typography variant="body1">
														{catLabels[i]}
													</Typography>
												} 
												secondary={
													`${
														total > 0 
														? Math.round(listSum[catID] / total * 100) 
														: 0
													}% - ${size(listQty[catID])} transaction${size(listQty[catID]) > 1 ? "s" : ""}`
												}
											/>
											<ListItemSecondaryAction>
												<ListItemText secondary={
													<Typography color="primary" variant="body2">
														<Currency value={listSum[catID]} />
													</Typography>} />
											</ListItemSecondaryAction>
										</ListItem>
										<Divider />
									</Fragment>
								)
							)}
						</List>
					</Grid>
				</Grid>
			</div>
		)
	}
}
function mapStateToProps(state){// transform elements from store's state into props in this component
	return {
		isAuthenticated: state.auth.isAuthenticatedAdmin,
		isSuper: state.auth.isSuperAdmin,
		CATEGORIES: state.categories,
		SPENDINGS: state.spendings,
		SUPPLIERS: state.suppliers,
		BANKS: state.banks,
		LABELS: state.labels,
		STATE: state.request.users
	}
}

function mapDispatchToProps(dispatch){
	return bindActionCreators({
		fetchParentCategories,
		fetchChildCategories,
		fetchUserSpendings,
		fetchAdminSpendings,
		fetchSpendingPayments,
		fetchSuppliers,
		fetchBanks,
		fetchLabels,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(DoughnutChart)